import type { PlaceholderValues, Rating } from "@homeinstead/schemas";
import type { ComponentType } from "react";
import type { ThankYouContentItem } from "./form-types";
import type { StepInputRendererProps } from "./StepInputRenderer";

import { BlockDebugDev } from "~www/components/PageBuilder/BlockDebugDev";
import { LeadFormPhoneLinkCtaFormButton } from "./LeadFormPhoneLinkCtaFormButton";
import { LeadFormRichTextBlockFormItem } from "./LeadFormRichTextBlockFormItem";
import { ReviewStarsFormItem } from "./ReviewStarsFormItem";

export interface ThankYouItemRendererProps {
  input: ThankYouContentItem;
  placeholderValues?: PlaceholderValues;
  phoneNumber?: string;
  officeRating?: Omit<Rating, "_type">;
}

const NOOP = () => {};

const THANK_YOU_COMPONENTS: Partial<
  Record<ThankYouContentItem["_type"], ComponentType<StepInputRendererProps>>
> = {
  phoneLinkCta: LeadFormPhoneLinkCtaFormButton,
  reviewStars: ReviewStarsFormItem,
  richTextBlock: LeadFormRichTextBlockFormItem,
};

export function ThankYouItemRenderer({
  input,
  placeholderValues,
  phoneNumber,
  officeRating,
}: ThankYouItemRendererProps) {
  const Component = THANK_YOU_COMPONENTS[input._type];

  if (!Component) {
    return <BlockDebugDev blockType={input._type} />;
  }

  return (
    <Component
      input={input}
      officeRating={officeRating}
      onContinue={NOOP}
      phoneNumber={phoneNumber}
      placeholderValues={placeholderValues}
    />
  );
}
